import { number, object, ObjectSchema } from 'yup';

import { MoneyValue } from '@client/api';

import { currencyValueSchema } from './CurrencyValue.schema';

const schema: ObjectSchema<MoneyValue> = object({
  amount: number().required(),
  currency: currencyValueSchema,
});

export { schema as moneyValueSchema };
